import request from "@/utils/request.js";
class Api {
  // 登录
  login(data) {
    return request({
      method: "post",
      url: "/login",
      data,
    });
  }
  // 退出
  logout() {
    return request({
      url: "/kf_user/login_out",
      method: "post",
    });
  }
  // 用户信息
  userInfo() {
    return request({
      url: "/kf_user/info",
      method: "get",
    });
  }
  // 轮询链接
  kfUserPing() {
    return request({
      url: "/kf_user/ping",
      method: "post",
    });
  }
  // 分配
  examineAssign(data) {
    return request({
      url: "/examine/assign",
      method: "post",
      data,
    });
  }
  // 切换客服状态
  autoAssignStatus(data) {
    return request({
      url: "/kf_user/auto_assign",
      method: "post",
      data,
    });
  }
}
export default new Api();
